<template>
    <div>
        <v-arrow
                ref="lien"
                :config="{
                    name:linkObj.data.ref,
                    points:radiusAjuste,
                    stroke:this.linkObj.data.color,
                    strokeWidth: 10,
                    listening:false,
                    perfectDrawEnabled:nothingIsMoving,
                }"
        ></v-arrow>
        <v-rect v-if="nothingIsMoving"
                @click="editLink"
                :config="{
                      x : centerOfLine.x,
                      y: centerOfLine.y,
                      width:300,
                      height:30,
                      offsetX:150,
                      offsetY:22,
                      rotation:getAngle,
                      listening:false,
                      }"></v-rect>

        <v-text v-if="nothingIsMoving"
                @click="editLink"
                :config="{
                      x : centerOfLine.x,
                      y: centerOfLine.y,
                      offsetX:150,
                      offsetY:22,
                      fill: 'black',
                      text: getText,
                      fontSize: 20,
                      fontStyle:'bold',
                      align:'center',
                      width: 300,
                      rotation:getAngle,
                      listening:false,
                      }"></v-text>

        <v-image v-if="nothingIsMoving"
                 @click="deleteLink"
                 :config="{
                      x : radiusAjuste[0]-8,
                      y: radiusAjuste[1]-8,
                      image:imgClose,
                      }"></v-image>

    </div>
</template>

<script>

    export default {
        name: 'lien',
        data (){
            return {

                imgClose:null,

                rad90:Math.PI/180,
            }
        },
        components: {},

        props: ['linkObj'],

        computed: {

            //Flag : On dessine que si rien ne bouge
            nothingIsMoving(){
              return !this.$store.getters.isSomeThingMoving
            },

            label(){
                const msg=this.linkObj.data.label
               return msg
            },

            //optimisation pour pas le recalculer 36 fois...
            lAngle(){
                const p=this.linkObj.points
                const dx = p[2] - p[0];
                const dy = p[3] - p[1];
                let angle = Math.atan2(-dy, dx);

                return angle
            },

            //Ajustement des coor pour que la fleche n'aille pas de centre à centre
            radiusAjuste(){

                const p=this.linkObj.points

                let radius = 130;
                let ecart=40

                let decaleSin=0
                let decaleCos=0

                //if(this.linkObj.data.decale!==0)
                {
                    decaleSin=this.linkObj.data.decale*ecart* Math.sin(this.lAngle+ this.rad90)
                    decaleCos=this.linkObj.data.decale*ecart* Math.cos(this.lAngle+  this.rad90)
                }

                return [
                    p[0] + -radius * Math.cos(this.lAngle + Math.PI) + decaleSin,
                    p[1] + radius * Math.sin(this.lAngle + Math.PI) + decaleCos ,
                    p[2] + -radius * Math.cos(this.lAngle)+ decaleSin,
                    p[3] + radius * Math.sin(this.lAngle)+ decaleCos
                ];
            },
            getText(){
                return this.label
            },
            getAngle(){
                const p=this.linkObj.points
                let dx = p[2] - p[0];
                let dy = p[3] - p[1];

                if(p[2]<p[0]){
                    dx = p[0] - p[2];
                    dy = p[1] - p[3];
                }

                let angle = -Math.atan2(-dy, dx)*(180/Math.PI);
                return angle
            },

            centerOfLine(){
                let p=this.radiusAjuste
                const minx=Math.min(p[2],p[0])
                const miny=Math.min(p[1],p[3])
                const dx = (p[2] - p[0])/2;
                const dy = (p[3] - p[1])/2;

                const coor={x:(dx+p[0]),y:(dy+p[1])}

                return coor
            },

            storeDeleteMe(){
                this.$store.commit('DELETE_LINK',this.linkObj.data.ref);
            },
        },
        methods: {
            async deleteLink(){
                try {
                    await this.storeDeleteMe
                    await this.$mydb.do.deleteLink(this.linkObj.id);
                }
                catch(e) {
                    console.log("Erreur:" + e)
                }
            },
            editLink(){
                const toEdit={
                    name:'TabLien',
                    config:this.linkObj
                }
                this.$store.commit('DROITE_SET',toEdit);
                console.log("send event")
            },
            editResult(){

            }

        },
        created() {
            const image = new window.Image();
            image.src = "close.png";
            image.onload = () => {
                // set image only when it is loaded
                this.imgClose = image;
            };
        },
        mounted(){

        }
    }

</script>

<style lang="scss">



</style>